import { loginUserAction, registerUserAction, fetchUserDataAction } from '../store/slices/authSlice';
import store from '../store/index';

// Generate random password (8 characters)
const generateRandomPassword = () => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let password = '';
  for (let i = 0; i < 8; i++) {
    password += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return password;
};

// Auto register and login user
export const autoRegisterAndLogin = async (userData) => {
  try {
    const { fullName, email, phoneNumber } = userData;
    const randomPassword = generateRandomPassword();
    
    // Register the user
    const registerResult = await store.dispatch(registerUserAction({
      fullName,
      email,
      phoneNumber,
      password: randomPassword,
      confirmPassword: randomPassword
    }));

    if (registerResult.meta.requestStatus === 'rejected') {
      const payload = registerResult.payload;

      const message =
        payload?.error?.[0]?.msg ||  // in case of field-level error array
        payload?.message ||          // in case of string message like "Email already exists"
        'Registration failed';

      throw new Error(message);
    }

    // Auto login with the generated password
    const loginResult = await store.dispatch(loginUserAction({
      email,
      password: randomPassword,
      rememberMe: false
    }));

    if (loginResult.error) {
      throw new Error(loginResult.error.message || 'Auto login failed');
    }

    const currentState = await store.dispatch(fetchUserDataAction());
    const user = currentState.payload;
    return user; // Return the logged in user

  } catch (error) {
    console.error('Auto registration/login error:', error);
    throw error;
  }
};

// Check if user is logged in
export const isUserLoggedIn = () => {
  return !!localStorage.getItem('authToken');
};

// Get user token
export const getUserToken = () => {
  return localStorage.getItem('authToken');
};

// Logout user
export const logoutUser = () => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('user');
  window.location.href = '/login';
};

// Check if token is expired
export const isTokenExpired = (token) => {
  if (!token) return true;
  
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.exp * 1000 < Date.now();
  } catch (error) {
    return true;
  }
};

// Check if user can view private campaigns (must be logged in and Admin)
export const canViewPrivateCampaign = (user, isAuthenticated) => {
  // Must be logged in
  if (!isAuthenticated || !user) {
    return false;
  }
  
  // Check if user has Admin role
  const roleName = user?.Role?.name || user?.role?.name || null;
  return roleName === "Admin" || roleName === "admin";
};